export type FlexiAssessmentMode = 'text' | 'guided';

export interface GuidedAnalyticsSession {
  startedAt: number;
  assessmentStartedAt: number | null;
  stepEnteredAt: number;
  editCount: number;
}

export interface TextModeAnalyticsContext {
  encounterId: string | null;
  routeName?: string | null;
  textModeStartedAt?: string;
  mode?: FlexiAssessmentMode;
  panelName?: string;
  stepIndex?: number;
  stepCount?: number;
  assessmentPath?: string;
  guidedSession?: GuidedAnalyticsSession;
}

let activeTextModeContext: TextModeAnalyticsContext | null = null;

export function setActiveTextModeContext(context: TextModeAnalyticsContext): void {
  activeTextModeContext = { ...context };
}

export function getActiveTextModeContext(): TextModeAnalyticsContext | null {
  return activeTextModeContext ? { ...activeTextModeContext } : null;
}

export function updateActiveTextModeContext(patch: Partial<TextModeAnalyticsContext>): void {
  if (!activeTextModeContext) return;
  activeTextModeContext = { ...activeTextModeContext, ...patch };
}

export function clearActiveTextModeContext(): void {
  activeTextModeContext = null;
}

export function resolveAssessmentMode(
  context: Pick<TextModeAnalyticsContext, 'mode'> | null | undefined,
): FlexiAssessmentMode {
  return context ? (context.mode || 'text') : 'guided';
}
